import React from 'react'
import { connect } from 'react-redux';

import { resetPlan } from '../../actions/entitlements';

class EntitlementForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      domain: 'com.familienort.my',
      plan: 'free',
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.changeDomain = this.changeDomain.bind(this);
    this.changePlan = this.changePlan.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();

    const { dispatch, user } = this.props;

    console.log(this.state);

    dispatch(resetPlan(user.uuid, this.state));
  }

  changeDomain(e) {
    this.setState({ domain: e.target.value });
  }

  changePlan(e) {
    this.setState({ plan: e.target.value });
  }

  render() {
    return (
      <form className="mb-10" onSubmit={this.onSubmit}>
        <h4>Assign new plan</h4>
        
        <input type="text"
          name="domain"
          className="border py-1 px-2 mr-2"
          onChange={this.changeDomain}
          value={this.state.domain} />

        <input
          type="text"
          name="plan"
          onChange={this.changePlan}
          className="border py-1 px-2 mr-2"
          value={this.state.plan} />

        <input
          className="py-1 px-2 border border-transparent shadow-sm rounded-md text-white bg-green-600"
          type="submit" />

      </form>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return({});
}

export default connect(mapStateToProps)(EntitlementForm);
